import { NavigateFunction } from "react-router-dom";
import envVariables from "src/lib/envVariables";
import ensureLeadingSlash from "src/lib/sanitizePath";

const IGNORED_PARAMS = ["token", "lookupKey", "path"];
const PARAMS_TO_ADD = new URLSearchParams([["from", "tc-ott"]]);

/**
 * `ensureLeadingSlash` throws on external URLs, protocols and path traversal.
 * That rejection must not be fatal here: by the time this runs the member is
 * already authenticated, so an unusable `?path=` should be dropped in favour of
 * the default destination rather than blocking a handover that worked. A throw
 * used to surface as "Could not set credentials" on a successful login.
 */
const safeDestination = (path: string | undefined): string => {
  for (const candidate of [path, envVariables.BASE_PATH, "/"]) {
    if (!candidate) {
      continue;
    }
    try {
      return ensureLeadingSlash(candidate);
    } catch {
      continue;
    }
  }
  return "/";
};

export const handleAuthSuccess = (navigate: NavigateFunction) => {
  const currentQuery = new URLSearchParams(
    decodeURIComponent(window.location.search)
  );
  const queryPath = currentQuery.get("path") ?? undefined;
  IGNORED_PARAMS.forEach((key) => currentQuery.delete(key));
  const tmpUrl = new URL(safeDestination(queryPath), window.location.origin);
  const extractedPath = tmpUrl.pathname;
  const processedSearch = new URLSearchParams(tmpUrl.search);

  const finalSearch = new URLSearchParams();
  [processedSearch, currentQuery, PARAMS_TO_ADD].forEach((params) =>
    params.forEach((value, key) => finalSearch.set(key, value))
  );

  navigate(`${extractedPath}?${finalSearch.toString()}`, { replace: true });
};
